import { ngettext } from '@sdk/lang/gettext';

export const formatEmployeeCountAppendix = (count: number) =>
  ngettext('%(count)s Employee', '%(count)s Employees', count, {
    count,
  });
